import ContentContainer from "layout/Content/ContentContainer";
import { useTitle } from "hooks/useTitle";
import { useLocation } from "react-router-dom";
import TopBanner from "layout/TopBanner/TopBanner";
import useEntity from "hooks/useEntity";
import Loader from "components/ui/Loader/Loader";
import Alert from "components/ui/Alert/Alert";
import Paragraphs from "components/ui/Paragraphs/Paragraphs";

function Page({ title, bundle, contentGridType, contentPadding, contentBackground, topBanner, topBannerImage, containerPadding }) {
  const location = useLocation();
  useTitle(title);
  const { entity, isLoading, error } = useEntity(location.pathname, bundle);
  if (isLoading) {
    return <Loader containerVariant={ 'fixed' }/>;
  }

  if (error) {
    return <Alert message={ error }/>;
  }

  if (!entity) {
    return <Alert message={ 'Er is geen inhoud beschikbaar voor de opgevraagde pagina' }/>;
  }

  return (
    <>
      {
        topBanner && <TopBanner title={ title || entity.title.value }
                                   intro={ entity.field_intro?.value }
                                   image={ topBannerImage }/>
      }

      <ContentContainer contentGridType={ contentGridType }
                        contentPadding={ contentPadding }
                        contentBackground={ contentBackground }
                        containerPadding={ containerPadding }>
        <h1>{ entity.title.value }</h1>
        { entity.field_content ? <Paragraphs items={ entity.field_content }/> : null }
      </ContentContainer>
    </>

  );
}

export default Page;
